import { createAction } from "redux-actions";
import { CollectionShort } from "../../types/Collection";

export const ADD_COLLECTIONS = 'ADD_COLLECTIONS';

export const addCollectionsAction = createAction<CollectionShort[]>(ADD_COLLECTIONS);
